import { render, staticRenderFns } from "./ClientSingle.vue?vue&type=template&id=a9140006&"
import script from "./ClientSingle.vue?vue&type=script&lang=js&"
export * from "./ClientSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports